module.exports = __webpack_public_path__ + "img/fuelpump.32f9ebf6.png";